import Vue from 'vue'
import Vuex from 'vuex'

// Import modules
import auth from 'src/vuex/modules/auth'
import users from 'src/vuex/modules/users'
import google from 'src/vuex/modules/google'
import issues from 'src/vuex/modules/issues'
import sectors from 'src/vuex/modules/sectors'
import meetings from 'src/vuex/modules/meetings'
import contacts from 'src/vuex/modules/contacts'
import projectsOfContact from 'src/vuex/modules/contactProjects'
import countries from 'src/vuex/modules/countries'
import presences from 'src/vuex/modules/presences'
import phases from 'src/vuex/modules/phases'
import contents from 'src/vuex/modules/contents'
import places from 'src/vuex/modules/places'
import trainings from 'src/vuex/modules/trainings'
import firstintervenants from 'src/vuex/modules/firstintervenants'
import allowances from 'src/vuex/modules/allowances'
import subSectors from 'src/vuex/modules/subsectors'
import socialStatuses from 'src/vuex/modules/socialStatuses'
import contractTypes from 'src/vuex/modules/contractTypes'
import problematiques from 'src/vuex/modules/problematiques'
import educationLevels from 'src/vuex/modules/educationLevels'
import familySituations from 'src/vuex/modules/familySituations'
import incubatorRewards from 'src/vuex/modules/incubatorRewards'
import partnerSituations from 'src/vuex/modules/partnerSituations'
import companies from 'src/vuex/modules/companies'
import jobs from 'src/vuex/modules/jobs'
import courses from 'src/vuex/modules/courses'
import courseTypes from 'src/vuex/modules/courseTypes'
import structureTypes from 'src/vuex/modules/structureTypes'
import statutEntrepreneurs from 'src/vuex/modules/statutEntrepreneurs'
import instructors from 'src/vuex/modules/instructors'
import prescriptors from 'src/vuex/modules/prescriptors'
import taxRegimes from 'src/vuex/modules/taxRegimes'
import welfareRegimes from 'src/vuex/modules/welfareRegimes'
import projects from 'src/vuex/modules/projects'
import projectTypes from 'src/vuex/modules/projectTypes'
import projectStatus from 'src/vuex/modules/projectStatus'
import capes from 'src/vuex/modules/capes'
import cers from 'src/vuex/modules/cers'
import sorties from 'src/vuex/modules/sorties'
import clubs from 'src/vuex/modules/clubs'
import caes from 'src/vuex/modules/caes'
import trackingPlaces from 'src/vuex/modules/trackingPlaces'
import referentAdvisers from 'src/vuex/modules/referentAdvisers'

// Import plugins
import createLogger from 'src/vuex/plugins/logger' // Should be in Vuex package, absent since 1.0.0
import authPlugin from 'src/vuex/plugins/auth'
import googleTokenPlugin from 'src/vuex/plugins/google'
import meetingUsersStoragePlugin from 'src/vuex/plugins/meeting'

Vue.use(Vuex)
Vue.config.debug = process.env === 'development'

// TODO check env and remove dev plugins
// Merge modules and plugins
const store = new Vuex.Store({
  modules: {
    auth,
    users,
    google,
    issues,
    sectors,
    meetings,
    contacts,
    projectsOfContact,
    countries,
    presences,
    phases,
    contents,
    places,
    trainings,
    firstintervenants,
    allowances,
    subSectors,
    socialStatuses,
    contractTypes,
    problematiques,
    educationLevels,
    familySituations,
    incubatorRewards,
    partnerSituations,
    companies,
    jobs,
    courses,
    courseTypes,
    structureTypes,
    statutEntrepreneurs,
    instructors,
    prescriptors,
    taxRegimes,
    welfareRegimes,
    projects,
    projectTypes,
    projectStatus,
    capes,
    cers,
    sorties,
    clubs,
    caes,
    referentAdvisers,
    trackingPlaces
  },
  strict: Vue.config.debug,
  plugins: [
    authPlugin,
    createLogger(),
    googleTokenPlugin,
    meetingUsersStoragePlugin
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js